
/*
*###############################################################################
*Module Name                   : TaxMasterTab.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Minol Prageesha                              #
*Date                          : Tuesday, August 31st 2021, 8:16:45 pm         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useState } from "react"
import { CardText, Col, Row, Button, Alert } from "reactstrap"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import DPTextBox from "../../../framework/components/DPTextBox"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/Tax.xlsx";
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const TaxMasterTab = ({
  GetSelectRow,
  strCusTaxCode,
  strCusTaxCodeonChange,
  strCusTaxDesc,
  strCusTaxDesconChange,
  dbRate,
  dbRateonChange,
  dbRateonBlur,
  dbDisplayRateonBlur,
  dbDisplayRate,
  dbDisplayRateonChange,
  disabled,
  disabledCode,
  AlertColor,
  AlertMsg,
  modelTrigger,
  modelOpen,
  show,
  ErrorMsg,
  findCode,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  showFileUpload,
  valueUpload,
  menuCode,
  autoCode

}) => {
  const [TaxColumns, setTaxColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL

  async function tog_backdrop() {
    modelTrigger();
  }


  useEffect(async () => {
    setTaxColumns(await loadPopupSearchPay(menuCode, 'TAX'))
  }, [menuCode]);

  //default sorted method
  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];
  return (
    <form>
      <React.Fragment>
        <div>
          <Col sm="12">
            <CardText className="mb-0">
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Row>
                <Col sm={12} md={7} className="mb-4-sm">
                  <DPTextBoxButton
                    rowClass="mb-4-sm"
                    labelText="Code *"
                    textType="text"
                    maxLength="3"
                    value={strCusTaxCode}
                    onChange={strCusTaxCodeonChange}
                    onBlur={findCode}
                    disabled={disabled == true ? disabled : disabledCode}
                    onButtonClick={onButtonClick}
                    btnDisable={disabled == true ? disabled : btnDisable}
                    placeholder={autoCode}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Description *"
                    textType="text"
                    maxLength="100"
                    value={strCusTaxDesc}
                    onChange={strCusTaxDesconChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Tax Rate %"
                    textType="text"
                    maxLength="5"
                    defaultValue="0.0"
                    textAlign="right"
                    value={dbRate}
                    onBlur={dbRateonBlur}
                    onChange={dbRateonChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Display Rate %"
                    textType="text"
                    maxLength="5"
                    defaultValue="0.0"
                    textAlign="right"
                    value={dbDisplayRate}
                    onBlur={dbDisplayRateonBlur}
                    onChange={dbDisplayRateonChange}
                    disabled={disabled}
                  />
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <Button
                    onClick={() => {
                      tog_backdrop()
                    }}
                    color="success"
                    className="btn-sm"
                    disabled={SearchDisable}
                  >
                    <i
                      className="mdi mdi-search-web"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </Col>
                <Col sm={12} md={2} className="mb-4-sm">
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={disabledCode}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />
                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                        style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>
                </Col>

                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={TaxColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={menuName + " Search"}
                  SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"TAX"}
                  MenuCode={menuCode}
                  KeyVal={"TAX"}
                  searchBy={"TAX_CODE"}
                  FilterStr={groupFilter}
                />
              </Row>

            </CardText>
          </Col>

        </div>
      </React.Fragment>
    </form>
  )
}
export default TaxMasterTab
